import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { RoutesEnum, RoutingService } from '../';
import { FeatureManagerService } from '../global/feature-manager/feature-manager.service';

@Injectable()
export class AuthV2GuardService implements CanActivate {
    constructor(
        public routingService: RoutingService,
        public featureManagerService: FeatureManagerService) { }

    canActivate(_route: ActivatedRouteSnapshot): Promise<boolean> {

        return new Promise((resolve) => {
            this.routingService.navigateToRoute(RoutesEnum.loginV2);
        });
    }
}
